import React, { Component } from "react";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import { NewContact, EditContact } from "./ministry_contact_popup";
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";

var backend = require('../../config.js').backend;

class Ministry_Contact_Mgm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            contacts: {},
            showPopup: false,
            showEditPopup: false,
            edit: {},
            allDesigs: {},
            returned: false,
            staffid: sessionStorage.getItem('id_e'),
            redirectLogout: false
        };

    }

    componentDidMount() {

        var { allDesigs } = this.state;
        if (!allDesigs.length) {
            this.getDesigs();
        }
        this.getMinistryContacts();

    }


    getDesigs = () => {

        this.getDesigData()
            .then((allDesigs) => {
                this.setState({ allDesigs: allDesigs });
            })

    }


    getDesigData = () => {

        var that = this;

        return new Promise(function (resolve, reject) {

            fetch(backend + `api/v1/gift/alldesignames`, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    } else {
                        resolve(data);
                    }
                })
                .catch((err) => {
                    reject(err)
                })

        })

    }

    getMinistryContacts = _ => {

        this.getContactsData()
            .then((result) => {
                this.setState({ contacts: result });
                this.setState({ returned: true })
            })

    }


    // Get all ministry contacts
    getContactsData = _ => {

        var that = this;

        return new Promise(function (resolve, reject) {

            fetch(backend + 'api/v1/ministrycontact/all', {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    } else {
                        resolve(data);
                    }
                })

        });

    }



    // Create new ministry contact
    handleNewContact = _ => {
        this.togglePopup();
    }

    togglePopup = _ => {
        this.setState({ showPopup: !this.state.showPopup });
    }

    // Edit exist ministry contact
    handleEdit = (index, contact) => {
        this.setState({ editContact: contact });
        this.toggleEditPopup();
    }

    toggleEditPopup = _ => {
        this.setState({ showEditPopup: !this.state.showEditPopup });
    }



    handleDelete = (index, contact) => {

        var answer = window.confirm("Are you sure you want to delete this contact " + contact.Name + "?")

        if (answer) {

            this.deleteContactFromSQL(contact.ContactID)
                .then((deleteResult) => {

                    if (deleteResult) {
                        this.getMinistryContacts();
                    }

                })
                .catch((err) => {
                    NotificationManager.error(contact.Name + ' cannot be deleted due to ' + err.toString());
                });

        }

    }

    deleteContactFromSQL = (contactId) => {

        var that = this;

        return new Promise(function (resolve, reject) {

            fetch(backend + `api/v1/ministrycontact/` + contactId, {
                method: 'DELETE',
                credentials: "include"
            })
                .then(response => response.json())
                .then((response) => {

                    if (response.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (response.status === 500) {
                        NotificationManager.error('Ministry Contact cannot be deleted, ' + response.message);
                    }
                    else {
                        // have not tested
                        NotificationManager.success('Ministry Contact is deleted successfully');
                        resolve(response)
                    }


                })
                .catch(err => console.error(err));

        })

    }


    renderDate = (date) => {
        if (date) {
            try {
                return moment(date).format('DD-MMM-YYYY');
            }
            catch (e) {
                // console.log('renderDate', e);
                return '';
            }
        }

        else {
            // console.log('renderDate no date passed');
            return '';
        }
    }

    renderContactRow = (contact, index) => {
        // console.log(contact);

        return (
            <tr key={index}>
                <td>{contact.Name}</td>
                <td>{contact.Email1}</td>
                <td>{contact.Email2}</td>
                <td>{contact.Email3}</td>
                <td>{this.renderDate(contact.StartDate)}</td>
                <td>{this.renderDate(contact.EndDate)}</td>
                {/* <td>{contact.Creator}</td>
                <td>{contact.Terminator}</td> */}
                <td>
                    <div className='icons'>
                        <EditIcon onClick={() => this.handleEdit(index, contact)} />
                        <DeleteIcon onClick={() => this.handleDelete(index, contact)} />
                    </div>
                </td>
            </tr>
        )

    }

    renderMinistry = (ministry, index) => {
        var { allDesigs } = this.state;

        var ministryId = ministry.ministryId;
        var contacts = ministry.contacts;

        var ministryName = allDesigs[ministryId]

        return (
            <div className="ministry-table" id={index} key={index}>
                <h4 className="ministry-name">{ministryName}</h4>
                <div className="ministry-contacts-table">
                    <div className="table-container2">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th className='name'>Name</th>
                                    <th className='email1'>Email 1</th>
                                    <th className='email2'>Email 2</th>
                                    <th className='email3'>Email 3</th>
                                    <th className='startdate'>Start Date</th>
                                    <th className='enddate'>End Date</th>
                                    {/* <th className='creator'>Creator</th>
                        <th className='terminator'>Terminator</th> */}
                                    <th className='action'>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {contacts.map(this.renderContactRow)}
                            </tbody>

                        </table>
                    </div>

                </div>
            </div>)

    }

    renderContacts = _ => {

        var { contacts } = this.state;
        // console.log('renderContacts', contacts);

        if (!this.state.returned) {
            return (<div><h4>Loading...</h4></div>)
        }
        else {
            return (
                <div className="ministries-table">
                    {contacts.map(this.renderMinistry)}
                </div>
            )
        }

    }


    render() {

        var ministries = this.renderContacts()
        var { allDesigs } = this.state;
        var { staffid } = this.state;
        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        let content = (

            <div className='ministry-contact-mgm'>
                <h3>Ministry Contacts</h3>

                <div>


                    {(this.state.showPopup) ?
                        <div>
                            <RemoveCircleOutlineIcon onClick={this.handleNewContact} />
                            <label>Add New Ministry Contact</label>
                            <NewContact
                                closePopup={this.togglePopup.bind(this)}
                                refresh={this.getMinistryContacts}
                                ministries={allDesigs}
                                creator={staffid}
                            />
                        </div>
                        :
                        <div>
                            <AddCircleIcon onClick={this.handleNewContact} />
                            <label>Add New Ministry Contact</label>
                        </div>
                    }

                    {(this.state.showEditPopup) ?
                        <EditContact
                            closePopup={this.toggleEditPopup.bind(this)}
                            refresh={this.getMinistryContacts}
                            ministries={allDesigs}
                            contact={this.state.editContact}
                            editor={staffid}
                        />
                        : null
                    }

                </div>
                {ministries}

                <NotificationContainer />

            </div>

        )

        return content

    }

}

export default Ministry_Contact_Mgm;
